// extracted by mini-css-extract-plugin
export default {"loading":"Label_loading__ZhmaK","shimmer":"Label_shimmer__f4LH8"};